<template>
  <div class="headerBottom layout text_center">
    <template v-if="routeName() == 'home' || routeName() == 'apps'">
      <div class="searchDiv" v-animate="'searchDiv'">
        <p class="bannerText">
          “一网通办”服务中心
        </p>
        <div class="leftBottom">
          <el-input
              v-model="keywords"
              @change="toSearch"
              placeholder="输入您要搜索的关键字"
          /><span class="pointer" @click="toSearch"
          >搜索</span>
        </div>
      </div>
      <img class="indexBanner" v-animate="'indexBanner'" src="@/assets/images/banner_after (1).png" alt="">
    </template>
    <!-- <template v-if="routeName() == 'serviceC'">
      <div class="seviceContent" v-animate="'seviceContent'">
        <p class="bannerText">
          服务中心
        </p> -->
<!--        <ul class="serviceTipUl text_center pointer">-->
<!--          <li class="serviceTipLi" :class="totalTip == ''?'active':''" @click="$store.commit('updateTotalTip','')">-->
<!--            办理事项-->
<!--          </li>-->
<!--          <li class="serviceTipLi" :class="totalTip == 'special'?'active':''"-->
<!--              @click="$store.commit('updateTotalTip','special')">专题服务-->
<!--          </li>-->
<!--        </ul>-->
      <!-- </div> -->
      <!-- <img class="serviceBanner" v-animate="'serviceBanner'" src="@/assets/images/banner_after (2).png" alt=""> -->
    <!-- </template> -->
    <!-- <template v-if="routeName() == 'todo'
                || routeName() == 'doing'
                || routeName() == 'done'
                || routeName() == 'meApply'
                || routeName() == 'flow_cc'
    ">
      <div class="sxContent" v-animate="'helpContent'">
        <p class="bannerText">
          个人中心
        </p>
      </div>
      <img class="sxBanner" v-animate="'sxBanner'" src="@/assets/images/banner_after (3).png" alt="">
    </template> -->
    <!-- <template v-if="routeName() == 'favorite'">
      <div class="searchDiv" v-animate="'helpContent'"> -->
        <!-- <p class="bannerText">
          我的收藏
        </p> -->
        <!-- <div class="leftBottom">
          <el-input
              v-model="keywordF"
              @change="toSearchF"
              placeholder="输入您要搜索的关键字"
          /><span style="background:var(--bgColor2);" @click="toSearchF"
          >搜索</span>
        </div>
      </div> -->
      <!-- <img class="helpBanner" v-animate="'helpBanner'" src="@/assets/images/banner_after (4).png" alt=""> -->
    <!-- </template> -->
  </div>
</template>

<script>
import {mapState} from "vuex";
import {EventBus} from "@/mixins/eventBus"

export default {
  name: "commonBanner",
  inject: ['routeName'],
  data() {
    return {
      keywords: '',
      keywordF: '',
    }
  },
  watch: {
    '$route.name': {
      handler(val, oldVal){
        if(val !== oldVal){
          this.keywords = null;
          this.keywordF = null;
        }
      }
    },
  },
  computed: {
    ...mapState(['totalTip'])
  },
  methods: {
    toSearch() {
      // if()
      if (this.keywords) {
        // this.$store.dispatch('updateQuery', {seq: this.keywords});
        // this.keywords=''
        this.$router.push({name:'serviceC', query: {seq: this.keywords}})
      }
    },
    toSearchF() {
      console.log(this.keywordF, '---')
      EventBus.$emit('changeQ', this.keywordF);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/commonBanner.vue